import React from 'react'
import ScheduleTitle from 'pages/app/shifts/partials/ScheduleTitle'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'

export default function ScheduleHeader ({ children }) {
  return (
    <div className='flex items-center justify-between mt-8 mb-3 xl:mt-12 xl:mb-4'>

      <div className='flex flex-col'>
        <UI.Text>
          <Translation name='shifts.partials.schedule_status' />
          <Displays.Enum name='status' enum='schedule_status' />
        </UI.Text>
        <div className='flex items-center whitespace-no-wrap'>
          <h2 className='text-xl font-medium mr-6'>
            <ScheduleTitle />
          </h2>
          <UI.Legend>
            <UI.LegendItem color='orange'>
              <Translation name='shiftexchange.legend.is-important' />
            </UI.LegendItem>
            <UI.LegendItem color='green'>
              <Translation name='shiftexchange.legend.is-ok' />
            </UI.LegendItem>
          </UI.Legend>
        </div>
      </div>

      {children}
    </div>
  )
}
